import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import PageHeaderWithActionBar from '@/components/common/Header/PageHeaderWithActionBar.vue'
import MailList from '@mail/components/MailList.vue'
import WebMailBottom from '@/components/common/WebMailBottom.vue'
import api from '@mail/api'
import { DeleteMode, FilterComparisonModes, FilterConditions, FilterContainmentModes } from '../types'
import { mapGetters, mapMutations } from 'vuex'
import * as types from '@mail/store/types'
@Component({
    components: { PageHeaderWithActionBar, MailList, WebMailBottom },
    computed: {
        ...mapGetters({
            selectList: types.EMAIL_SELECT
        })
    },
    methods: {
        ...mapMutations({
            selectEmailAll: types.EMAIL_SELECT_ALL,
            selectListClear: types.EMAIL_SELECT_CLEAR,
        })
    }
})
export default class ListContainer extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: String, default: null }) id!: string
    @Prop({ type: Object }) searchOptions!: mail.SearchOptions

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    mailList: any[] = []
    offset: number = 0
    pageNumber: number = 1
    pageSize: number = 20
    loadMorePossible: boolean = true

    totalCount: number = 0 //전체 숫자 2023-05-30 추가

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    selectList!: string[]

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    selectEmailAll!: (ids: string[]) => void
    selectListClear!: () => void

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    getMailList(options: mail.SearchOptions) {
        const {
            unreadOnly,
            query,
            sorts,
            hasAttachments,
            hasCategories,
        } = this.searchOptions
        const filters: mail.api.FilterOption[] = [];

        if (unreadOnly) {
            filters.push({
                key: 'IsRead',
                value: 'false',
                condition: FilterConditions.IsEqualTo,
            } as mail.api.FilterOption);
        }

        if (hasAttachments) {
            filters.push({
                key: 'HasAttachments',
                value: 'true',
                condition: FilterConditions.IsEqualTo,
            } as mail.api.FilterOption);
        }

        if (query) {
            filters.push({
                operator: 'or',
                filters: [
                    {
                        key: 'Subject',
                        value: query,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'From',
                        value: query,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'PR_DISPLAY_TO_W',
                        value: query,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    }
                    ,{
                        key: 'PR_DISPLAY_CC_W',
                        value: query,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    }
                    ,{
                        key: 'Body',
                        value: query,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                ],
            } as mail.api.FilterOption);
        }

        var data: mail.api.DynamicApiOptions = {
            fields: [
                { key: 'From', format: 'obj:[name,address]', as: 'fromS' },
            ],
            filters: filters,
            parentId: this.id,//null,//parentId || null,
            pageSize: this.pageSize,
            offset: (this.pageNumber -1) * this.pageSize,
            type: 'EmailMessage',
        };
        
        //추가 페이지 여부 확인 2023-05-30
        if(this.totalCount > 0){
            if (this.pageNumber > Math.ceil(this.totalCount/this.pageSize))
            {
                this.loadMorePossible = false
                return false
            }
        }

        api.mail.getPagedList(data).then((emails) => {
            if (emails.items.length) {
                this.totalCount = Number(emails.totalCount || 0) //총 개수 2023-05-30 추가
                if (this.pageNumber > 1) {
                    this.mailList = [...(this.mailList || []), ...emails.items]
                } else {
                    this.mailList = emails.items
                    this.isloading(false)
                }
            } else {
                this.mailList = []
                this.isloading(false)
                this.loadMorePossible = false
            }
        })
    }

    loadMore() {
        if (this.loadMorePossible) {
            this.pageNumber ++
            this.getMailList(this.searchOptions)
        }
    }
    
    async deleteItems() {
        const ids = this.selectList

        if (await(window as any).confirmAsync(this.$t('M_Mail_Msg20').toString()) == false) {
            return false
        } else {
            api.mail.delete({ ids, mode: DeleteMode.MoveToDeletedItems}).then((succeed) => {
                if (succeed) {
                    ids.forEach((id: any) => {
                        const idx = this.mailList.findIndex((e) => e.id === id);
                        const item = this.mailList[idx];
                        item.deleted = true;
                    })
                    this.selectListClear()
                    this.onChangedFolderId()
                } else {
                    ids.forEach(async (id: any) => {
                        const idx = this.mailList.findIndex((e) => e.id === id);
                        const item = this.mailList[idx];
                        item.deleted = false;
                        await(window as any).alertAsync(this.$t('다시_시도해주시기_바랍니다').toString())
                    })
                }
            }).catch(() => {
                ids.forEach(async (id: any) => {
                    const idx = this.mailList.findIndex((e) => e.id === id);
                    const item = this.mailList[idx];
                    item.deleted = false;
                    await(window as any).alertAsync(this.$t('다시_시도해주시기_바랍니다').toString())
                })
            })
        }
    }

    async moveItems(folderId: string) {
        const ids = this.selectList

        if (await(window as any).confirmAsync('선택하신 메일을 이동하시겠습니까?') == false) {
            return false
        } else {
            api.mail.moveEmails(ids, folderId).then((succeed) => {
                if (succeed) {
                    ids.forEach((id: any) => {
                        const idx = this.mailList.findIndex((e) => e.id === id);
                        const item = this.mailList[idx];
                        item.deleted = true;
                    })
                    this.selectListClear()
                    this.onChangedFolderId()
                    this.$emit('moveModalClose')
                } else {
                    ids.forEach((id: any) => {
                        const idx = this.mailList.findIndex((e) => e.id === id);
                        const item = this.mailList[idx];
                        item.deleted = false;
                    })
                }
            }).catch(() => {
                ids.forEach((id: any) => {
                    const idx = this.mailList.findIndex((e) => e.id === id);
                    const item = this.mailList[idx];
                    item.deleted = false;
                })
            })
        }
    }

    readItems() {
        this.selectList.forEach(id => {
            api.mail.changeReadState(id, true)
        })
    }

    selectAll() {
        var ids: string[] = []
        this.mailList.map(email => {
            ids.push(email.id)
        })
        this.selectEmailAll(ids)
    }

    loadDataReset() {
        this.mailList = []
        this.offset = 0
        this.pageNumber = 1
        this.pageSize = 20
        this.loadMorePossible = true
    }

    @Watch('searchOptions', {deep: true})
    onChangedSearchOptions() {
        this.getMailList(this.searchOptions)
    }

    @Watch('id')
    onChangedFolderId() {
        this.loadDataReset()
        this.getMailList(this.searchOptions)
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.isloading(true)
        this.getMailList(this.searchOptions)
    }
}
